import { Heart, XIcon } from 'lucide-preact';
import { ComponentProps } from 'preact';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/Buttons';
import { FollowHabitatTrackingData, useFollowHabitat } from '@/hooks/habitats';
import { useSelector } from '@/redux/helper';

import { setMembersOnlyWarningModalState } from '../MembersOnlyWarningModal/redux/actions';

interface FollowButtonProps extends ComponentProps<typeof Button> {
  habitatId: string;
  trackingData?: Omit<FollowHabitatTrackingData, 'habitatId'>;
}

const FollowButton = ({ habitatId, trackingData, onClick: onClickProp, ...props }: FollowButtonProps) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.user.logged);
  const { isFavorited, follow, unfollow, isError } = useFollowHabitat(habitatId, {
    trackingData: {
      habitatId,
      ...trackingData,
    },
  });

  const onClick: ComponentProps<typeof Button>['onClick'] = (e) => {
    if (!isLoggedIn) {
      dispatch(setMembersOnlyWarningModalState({ type: 'habitat' }));
      onClickProp?.(e);
      return;
    }

    if (isFavorited) {
      unfollow();
    } else {
      follow();
    }
    onClickProp?.(e);
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button variant={isFavorited ? 'tea' : 'yellow'} onClick={onClick} {...props}>
      {isError ? (
        <XIcon className="size-4 text-system-red" />
      ) : (
        <Heart className={isFavorited ? 'fill-current' : undefined} />
      )}
      {isError ? 'Try again' : isFavorited ? 'Following' : 'Follow'}
    </Button>
  );
};

export default FollowButton;
